//import { MetryAlarmsI18n } from 'alarmTypes.js'
import AlarmTypes from "./alarmTypes"

export default {
    custAlarms: {
        custAlarms: "Customer Alarms",
        alarmDefs: "Alarm Definitions",
        activeAlarms: "Active Alarms",
        alarmSuppression: "Alarm Suppressions",
        metricsList: "Active Alarm List",
        metricsDashboard: "Active Alarms Dashboard"
    },
    alarmsDashboard: {
        title: "Alarms Dashboard",
        groupBy: "Group By",
        severityLabel: "Severity",
        alarmTypeLabel: "Type",
        alarmCounts: "Active Alarm Counts",
        alarmCountsByDevice: "Alarm Counts By Source ID",
        alarmCountsByDay: "Alarm Counts By Day",
        alarmCountsByAge: "Alarm Counts By Age",
        alarmCountsByDeviceGraphLabel: "Count",
        alarmCountsByAgeGraphLabel: "Count",
        widgets: {
            alarmCount: {
                title: "Alarm Counts"
            },
            alarmCountByAge: {
                title: "Alarm Counts by Age",
                yAxisLabel: "Count",
                xAxisLabel: "Age (Days)"
            },
            alarmCountByDevice: {
                title: "Alarm Counts by Source ID",
                yAxisLabel: "Count",
                xAxisLabel: "Source ID"
            },
            alarmCountByDay: {
                title: "Alarm Counts by Day",
                yAxisLabel: "Count",
                xAxisLabel: "Day"
            }
        },
        lang: "EN",
        severity: {
            SEV00: "None",
            SEV10: "Critical",
            SEV20: "Major",
            SEV30: "Minor",
            SEV40: "Info",
            SEV50: "Unknown"
        },
        alarmType: AlarmTypes.alarmTypes
    },
    alarmsTrans: {
        critical: "Critical",
        major: "Major",
        minor: "Minor",
        info: "Info",
        none: "None"
    },
    alarm: {
        alarmMenu: "Manage Alarms",
        rule: "Rule",
        goToAlarmDetails: "Go to Alarm Details",
        alarmSeverity: 'Alarm Severity',
        alarmDefMappings: {
            createSuccess: "Alarm definition was successfully created",
            createFail: "Unable to create alarm definition",
            editSuccess: "Alarm definition was successfully edited",
            editFail: "Unable to edit alarm definition",
            overrideSuccess: "Global Alarm definition was successfully overridden",
            overrideFail: "Unable to override global alarm definition",
            activateSuccess: "Selected alarm definitions successfully activated",
            activateFail: "Unable to activate selected alarm definitions",
            deactivateSuccess: "Selected alarm definitions successfully deactivated",
            deactivateFail: "Unable to deactivate selected alarm definitions",
            deleteSuccess: "Selected alarm definition successfully deleted",
            deleteFail: "Unable to delete selected alarm definition",
            nameReq: "You must give your alarm a name",
            severityReq: "You need to select a severity",
            numberReq: "You must input a number",
            statReq: "You must select a statistic",
            freqReq: "You must select a frequency",
            baseStationReq: "You must enter a base station ID",
            operReq: "You must select an operator ",
            thresholdReq: "You must include an threshold value",
            clearReq: "You must include a clear value",
            threshClearInvalid: "Clear value must be {operator} threshold value",
            threshClearInvalidStandardDeviation: "Threshold value must be >= clear value and both must be >= 0",
            clearSuccess: "Alarms for this definition was successfully cleared",
            clearFail: "Unable to clear alarms for this definition",
            reqFilterMissing: "Required filter {name} missing",
            valueRequired: "Value required",
            stdDevRangeError: "Standard Deviation must be > 0 and <= 10",
            stdDevClearError: "Standard Deviation Threshold must be greater than Clear Standard Deviation",
            percentageRangeError: "Percentage must be > 0 and <= 100",
            percentageClearError: "Threshold Percentage must be greater than Clear Percentage",
            changeOptOutSuccess: "Opt out setting changed successfully",
            changeOptOutFail: "Opt out setting change failed"
        },
        actions: {
            create: "Create Alarm Definition",
            edit: "Edit Selected Alarm Definitions",
            delete: "Delete Selected Alarm Definition",
            activate: "Activate Selected Alarm Definitions",
            deactivate: "Deactivate Selected Alarm Definitions",
            clear: "Clear Alarms for Selected Alarm Definition",
            override: "Override Global Alarm"
        },
        detailActions: {
            actions: "Actions",
            ack: "Acknowledge",
            unack: "Unacknowledge",
            ignore: "Ignore",
            unignore: "Unignore",
            clear: "Clear"
        },
        detailActionsSubTitle: 'Alarm Actions',
        createDlogTitle: "Create New Alarm",
        editDlogTitle: "Edit Alarm",
        overrideDlogTitle: "Override Global Alarm",
        dlog: {
            name: "Name",
            severity: "Severity",
            description: "Description",
            descriptionHint: "Describe your alarm here.",
            thresholdValue: "Threshold Value",
            lastHeardThresholdValue: "Threshold Value (minutes)",
            percentageThresholdValue: "Threshold Value (percentage, 1-100)",
            clearValue: "Clear Value",
            frequency: "Frequency",
            baseStation: "Base Station ID",
            baseStationSearchPlaceholder: "Search by base station id or name ...",
            baseStationSearchNoMatches: "No matches found",
            baseStationSearchSearching: "Searching for matches...",
            isStdDev: "Use Standard Deviation",
            statistic: {
                label: "Statistic",
                statList: {
                    title: "statList",
                    itemValue: "value",
                    itemText: "text"
                }
            },
            operator: "Operator",
            value: "Value",
            disabledClearTooltip: "= and != Operators do not need a clear value",
            lastHeardOperatorTooltip: "Last Heard rules must use >=",
            standardDeviationDescriptionPlaceholder: "Alarm created when X standard deviations crosses Y.",
            descriptionPlaceholder: "Alarm created when X crosses Y.",
            trafficDrop: {
                stdDevMulti: "Std Dev Multiplier",
                percentageDrop: "Percentage Drop",
            }
        },
        dialogActions: {
            cancel: "Cancel",
            saveInactive: "Save as Inactive",
            saveActive: "Save and Activate"
        },
        general: "General",
        status: "Status",
        rules: "Rules",
        confirmDelete: "Are you sure you want to delete the rule?",
        canOptOut: "Allow Customers to Opt Out",
        canOverride: "Allow Customers to Override",
        isOptedOut: "Opted Out of Global Rule",
        optOutRule: "Opt Out of Global Alarm",
        optInRule: "Opt In to Global Alarm",
        optedOutCustomers: "Customers Opting Out",
        overriddenCustomers: "Customers Overriding",
        optOutRuleConfirm: "Are you sure you want to opt out of this global rule?",
        optOutRuleConfirmTitle: "Opt Out of Global Rule",
        optInRuleConfirm: "Are you sure you want to opt in to this global rule?",
        optInRuleConfirmTitle: "Opt In to Global Rule",
        overrideRuleConfirm: "Are you sure you want to override this global rule?",
        overrideRuleConfirmTitle: "Override Global Rule",
        cannotOverrideOptedOut: "Cannot override an opted out rule, must opt in first",
        threshold: "Threshold",
        pageTitle: "Alarm Definitions",
        configuration: "Alarm Configuration",
        id: "ID",
        name: "Name",
        isGlobal: "Global Rule",
        isOverridden: "Overrides Global Rule",
        createdBy: "Created By",
        lastUpdatedBy: "Last Updated By",
        description: "Description",
        severity: "Severity",
        standardDeviation: "Standard Deviation",
        gaussian: "Gaussian",
        thresholdRule: "Threshold Rule",
        clearRule: "Clearance Rule",
        triggerCount: "Trigger Count",
        activeAlarms: "Active Alarms",
        lastTrigger: "Last Trigger",
        filters: "Filters",
        state: "Rule State",
        alarms: "Alarms",
        lastHeard: "Last Heard",
        atMost1Day: "At Most 1 Day",
        oneTo3Days: "1 to 3 Days",
        threeTo5Days: "3 to 5 Days",
        fiveTo7Days: "5 to 7 Days",
        atLeast7Days: "Greater Than 7 Days",
        updateTime: "Last Updated",
        details: {
            title: "Alarm Details",
            vswr: "VSWR",
            reflectedPower: "Reflected Power",
            forwardPower: "Forward Power",
            messageNumber: "Message Number",
            tower: {
                alarm: {
                    reflectedPower: "Reflected Power",
                    reflected: {
                        power: "Reflected Power"
                    },
                    forwardPower: "Forward Power",
                    forward: {
                        power: "Forward Power"
                    }
                }
            },
            idleNoiseDB: "Idle Noise (db)",
            centerFrequencyHz: "Center Frequency",
            count: "Count",
            lastHeardTimestampMilli: "Last Heard",
            meter: {
                alarm: {
                    name: "Alarm",
                    snapshot: "Snapshot"
                }
            },
            triggerValue: "Trigger Value"
        },
        serviceErrors: {
            duplicateTriggerCondition: "The threshold rule must be unique",
            clearingError: "Error clearing alarm",
            configSendingDisabled: "Config Sending Disable error, you should not get this.",
            invalidFilter: "Invalid Filter",
            standardDeviationError: "Standard deviation rule processing error",
            standardDeviationNoBaseStationError: "Unable to find base station ID for standard deviation rule",
            standardDeviationNoStoredDataError: "Unable to find stored advanced statistics for base station",
            standardDeviationComputeError: "Unable to compute rule from base station's advanced statistics"
        },
        error: {
            dataRetrieval: "Error retrieving alarm data"
        }
    },
    metryAlarms: {
        pageTitle: "Active Alarms",
        min: "Min",
        max: "Max",
        columns: {
            suppressed: "Suppressed",
            suppressedBy: "Suppressed By",
            sourceClass: "Source Class",
            sourceType: "Source Type",
            sourceId: "Source ID",
            referenceId: "Reference ID",
            sourceComponent: "Component",
            alarmClass: "Alarm Class",
            alarmDefinition: "Alarm Definition",
            alarmType: "Alarm Type",
            severity: "Severity",
            details: "Details",
            startTime: "Start Time",
            endTime: "End Time",
            ackTime: "Acked On",
            ackedBy: "Acked By",
            userName: "Created By",
            sourceName: "Source Name",
            location: "Lat/Long"
        },
        filters: {
            sourceClass: "Source Class",
            sourceType: "Source Type",
            sourceId: "Source ID",
            referenceId: "Reference ID",
            sourceComponent: "Component",
            alarmClass: "Alarm Class",
            alarmType: "Alarm Type",
            severity: "Severity",
            startTime: "Start Time",
            endTime: "End Time",
            ackTime: "Acked On",
            ignoredBy: "Ignored Alarms",
            userName: "Created By",
            sourceName: "Source Name",
            details: {
                ruleId: "Rule Id"
            }
        },
        severity: {
            SEV00: "None",
            SEV10: "Critical",
            SEV20: "Major",
            SEV30: "Minor",
            SEV40: "Info",
            SEV50: "Unknown"
        },
        severityText: {
            Info: "Info",
            Minor: "Minor",
            Major: "Major",
            Critical: "Critical",
            Unknown: "Unknown"
        },
        ignoredAlarms: {
            "showIgnored": "Show Ignored Alarms Only",
            "hideIgnored": "Hide Ignored Alarms"
        },
        actions: {
            actions: "Actions",
            ack: "Acknowledge",
            unack: "Unacknowledge",
            ignore: "Ignore",
            unignore: "Unignore",
            clear: "Clear",
            downloadCsv: "Download Alarms CSV",
            suppressAlarm: "Suppress Alarm",
            unsuppressAlarm: "UnSuppress Alarm",
            updateFailed:"Failed to update Alarms"
        },
        sourceClass: {
            TOWER: "Base Station",
            RADIO: "Radio",
            DEVICE: "Device",
            UNKNOWN: "Unknown"
        },
        sourceClassSPR: {
            TOWER: "Base Station",
            RADIO: "Radio",
            UNKNOWN: "Unknown"
        },
        sourceComponent: {
            ANTENNA: "Antenna",
            APPLICATION: "Application",
            BATTERY: "Battery",
            DEVICE: "Device",
            ENCLOSURE: "Enclosure",
            METER: "Meter",
            METROLOGY: "Metrology",
            POWER: "Power",
            SENSOR: "Sensor",
            SMART_POINT: "Smart Point",
            STATISTIC: "Statistic",
            UNKNOWN: "Unknown"
        },
        alarmClass: {
            ENGINEERING: "Engineering",
            ENVIRONMENTAL: "Environmental",
            EQUIPMENT: "Equipment",
            FEATURE: "Feature",
            POWER: "Power",
            SECURITY: "Security",
            SERVICE: "Service",
            THRESHOLD: "Threshold",
            UNKNOWN: "Unknown"
        },
    },
    alarmSuppression: {
        now: "Now",
        never: "Never",
        startDate: "Suppression Start",
        allAlarmTypes: "All Alarm Types",
        allBaseStations: "All Base Stations",
        pageTitle: "Alarm Suppressions",
        createTitle: "Create Suppression Rule",
        editTitle: "Edit Suppression Rule",
        alarmTypes: "Alarm Types",
        baseStation: "Base Station",
        lastSuppressionTime: "Last Suppression Time",
        suppressionCount: "Suppression Count",
        save: "Save",
        createFail: "Unable to create alarm suppression rule",
        createSuccess: "Suppression rule created",
        createAction: "Create Alarm Suppression",
        editSuccess: "Suppression rule edited",
        editAction: "Edit Selected Alarm Suppression",
        deleteAction: "Delete Selected Alarm Suppression",
        inactiveAction: "Make Expired Selected Alarm Suppression",
        inactiveSuccess: "Suppression rule made expired",
        confirmInactive: "Are you sure you want to make this suppression rule expired?",
        confirmInactiveTitle: "Confirm Make Expired",
        suppressionHistoryDetails: "Alarm Suppression History Details",
        historyTooltip: "Suppression history has {cnt} entries.  Click on the icon to see the details.",
        commandSent: "Suppression call made, depending on the number of matching alarms, this might take some time"
    }
}
